// src/theme/theme.ts

export const colors = {
  primary: {
    yellow: "#FFD600", // Highlights, CTAs
    green: "#4CAF50", // Success, verification
    blue: "#2196F3", // Info, links, outgoing messages
    red: "#F44336", // Errors, escalated tickets
  },
  gray: {
    900: "#1F2937", // Text primary
    700: "#374151", // Text secondary
    500: "#6B7280", // Labels, meta
    300: "#D1D5DB", // Borders
    100: "#F3F4F6", // Background light - VERIFIED WORKING CORRECTLY
  },
  white: "#FFFFFF",
};

export const typography = {
  fontFamily: "'Inter', 'Roboto', sans-serif",
  sizes: {
    label: "12px",
    body: "14px",
    bodyLarge: "15px",
    heading: "16px",
    headingLarge: "18px",
  },
  weights: {
    regular: 400,
    medium: 500,
    bold: 700,
  },
};

export const radius = {
  sm: "6px",
  md: "12px",
  lg: "16px",
};

export const spacing = {
  xs: "4px",
  sm: "8px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  xxl: "40px",
};

export const shadows = {
  card: "0 1px 3px rgba(0,0,0,0.1)",
  dropdown: "0 4px 6px rgba(0,0,0,0.1)",
};

export const theme = {
  colors,
  typography,
  radius,
  shadows,
  spacing,
};
